import styled from 'styled-components';


export const Button = styled.div`
  position: relative;
  width: calc(0.8 * var(--width));
  height: calc(0.7 * var(--height));
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2), 0 3px 8px rgba(0,0,0,0.1);
  transition: all 0.3s cubic-bezier(0, 0.22, .3, 1);
  background: #C24728;
  border-radius: 0.6em;

  &:before{
    content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.1);
  }

  span{
    color: #fff;
		z-index: 10;
		text-transform: uppercase;
		letter-spacing: 2px;
  }

  .back{
    position: absolute;
		width: 0;
		height: 0;
		filter: url(#filter);
		border-radius: 50%;
		z-index: 5;
		transition: all 2.5s cubic-bezier(0.1, 0.22, .3, 1);
    left: -50%;
		top: -50%;
		background: #E08333;
  }

  &:hover .back{
    width: calc(2 * var(--width));
		height: calc(2 * var(--height));
  }
`

